module.exports = __webpack_public_path__ + "static/media/img2.ffc55ea6.jpg";